var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import CardImage from '../card-image';
import TextCard from '../card-text';
var emojiSizeMap = {
    image: 160,
    emoji: 30,
};
var CardEmoji = (function (_super) {
    __extends(CardEmoji, _super);
    function CardEmoji() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardEmoji.prototype.render = function () {
        var _a = this.props, _b = _a.templateData, templateData = _b === void 0 ? {} : _b, _c = _a.onLoad, onLoad = _c === void 0 ? function () { } : _c, _d = _a.emojiMap, emojiMap = _d === void 0 ? {} : _d;
        var emoji = emojiMap[templateData.txt] || {};
        var imgUrl = emoji.imgUrl, _e = emoji.type, type = _e === void 0 ? 'image' : _e;
        if (imgUrl) {
            var imgData = {
                imgUrl: imgUrl,
                width: emojiSizeMap[type],
                height: emojiSizeMap[type],
                txt: templateData.txt
            };
            return React.createElement(CardImage, __assign({ className: "message-emoji", onLoad: onLoad }, this.props, { templateData: imgData }));
        }
        else {
            return React.createElement(TextCard, __assign({}, this.props, { displayTranslate: false }));
        }
    };
    return CardEmoji;
}(React.Component));
export default CardEmoji;

//# sourceMappingURL=index.js.map
